import React from 'react'
import Features from '../components/specified/wallet/Features'
import Hero from '../components/specified/wallet/Hero'
import Info from '../components/specified/wallet/Info'

import WalletComp from '../components/specified/home/Wallet'
import { Container } from '../components/styleguide/layout'
import Cta from '../components/common/Cta'
import MoreFeatures from '../components/specified/wallet/MoreFeatures'

const Wallet = () => {
  return (
    <>
      <Hero />
      <Info />
      <Features />

      <Container>
        <WalletComp primary />
      </Container>
      <MoreFeatures />
      <Container>
        <Cta />
      </Container>
    </>
  )
}

export default Wallet